import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ru from './translations/ru.json';
import uz from './translations/uz.json';

const resources = {
	ru: ru,
	uz: uz
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'ru',
		resources: resources,
		detection: {
			order: ['querystring'],
			lookupQuerystring: 'lng'
		},
		interpolation: {
			escapeValue: false
		}
	}).then(() => console.log('i18n connected'));

export default i18n;